import Vue from 'vue';
import { UserService } from '@/services/UserService';
import { AssociationService } from '@/services/AssociationService';
import { AspNetRole, AssociationRoleEnum } from '../../models/Enums';
import SelectListItem from '../../models/SelectListItem';
import AdminRegistrationRequest from '../../models/api/user/AdminRegistrationRequest';
import UserRegistrationRequest from '../../models/api/user/UserRegistrationRequest';
import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
import { DataTableHelper } from '@/helpers/DataTableHelper';
import { SnackbarService } from '../../services/SnackbarService';
import GetExpanderClasses from '../../helpers/functions/GetExpanderClasses';

export default Vue.extend({
    components: {
        DeleteDialog
    },
    data() {
        return {
            // Table
            expanded: [],
            singleExpand: false,
            totalCount: 0,
            items: [],
            loading: true,
            options: {},
            headers: [
                {
                    text: 'name',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'emailAddress',
                    value: 'email'
                },
                {
                    text: 'association.association',
                    value: 'associationName',
                },
                {
                    text: 'group.groupName',
                    value: 'groupNames',
                },
                {
                    text: 'role',
                    value: 'role'
                },
                {
                    text: 'user.emailConfirmed',
                    sortable: true,
                    value: 'emailConfirmed',
                    align: 'center',
                },
                {
                    text: '',
                    sortable: false,
                    value: 'action'
                },
                //{
                //    text: '',
                //    value: 'data-table-expand'
                //},
            ],
            headersAssociationUsers: [
                {
                    text: 'name',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'association.association',
                    sortable: false,
                    value: 'associationName'
                },
                {
                    text: 'role',
                    value: 'role',
                },
            ],


            //Comment out everything that has to do with delete of association adminuser, should be done in person register for now anyway
            // Delete dialog
           
            //showDelete: false,
            //itemToDeleteId: "",
            //itemToDeleteName: "",
        }
    },
    created() {
        DataTableHelper.adaptTableHeaders(this.headers, this);
        DataTableHelper.adaptTableHeaders(this.headersAssociationUsers, this);

        this.getUsersPaged();
    },
    watch: {
        options: {
            handler() {
                this.getUsersPaged();
            },
            deep: true,
        },
    }, methods: {
        getExpanderClass(isExpanded: boolean): string {
            return GetExpanderClasses(isExpanded);
        },
        getRoles(user: any): string {
            const roles = user.associationUsers.map((s: any) => this.$vuetify.lang.t('$vuetify.association.' + this.getAssociationRoleName(s.role)));

            const uniqueRoles = Array.from(new Set(roles));
            return uniqueRoles.join(", ");
        },
        getAssociationRoleName(role: AssociationRoleEnum) {
            return AssociationRoleEnum[role];
        },
        getRoleName(role: AspNetRole) {
            return AspNetRole[role];
        },
        async getUsersPaged() {
            this.loading = true;

            const sortBy = (this.options as any).sortBy ?? [];
            const sortDesc = (this.options as any).sortDesc ?? [];
            const page = (this.options as any).page ?? 1;
            const itemsPerPage = (this.options as any).itemsPerPage ?? 10;

            const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage };

            UserService.GetUsersPaged(data).then(response => {
                this.totalCount = response.data.totalCount;
                this.items = response.data.items;
                /*this.items.forEach((s: any) => { s.canExpand = s.role == AspNetRole.AssociationUser; });*/

            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        async sendConfirmEmail(email: string) {
            window.location.href.lastIndexOf("#/")
            const validateEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            this.$store.commit('addOverlay');

            UserService.SendConfirmEmail({ email: email, emailConfirmationUrl: validateEmailUrl }).then(() => {
                SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.confirmEmailSent'));
            }).catch((error) => {
                if (error.response.data.errors) {
                    SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                } else {
                    SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                }
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });
        },
        //async showDeleteDialog(id: string, name: string) {
        //    this.itemToDeleteId = id;
        //    this.itemToDeleteName = name;
        //    this.showDelete = true;
        //},
        //async deleteCallback(itemToDeleteId: string) {
        //    this.showDelete = false;

        //    if (itemToDeleteId) {
        //        this.$store.commit('addOverlay');
        //        UserService.DeleteUser(this.itemToDeleteId).then(() => {
        //            SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.removedMessage'));
        //            this.getUsersPaged();
        //        }).catch((error) => {
        //            if (error.response.data.errors) {
        //                SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
        //            } else {
        //                SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
        //            }
        //        }).finally(() => {
        //            this.$store.commit('removeOverlay');
        //        });
        //    }
        //}
    },
});
